<div class="modal {{padding()}}">
  <app-dialog [opened]="opened" (openedChange)="changeState.emit(false)" [modalCenter]="true">
    <div [ngClass]="align()" class="content">
      <ng-content select="[modal-title]" />
      <div [ngClass]="'text-'+alignContent()"><ng-content select="[modal-content]" /></div>
      @if (!hideButtons()) {
        @if (leftButton()) {
          <div class="d-flex justify-content-between">
            <button id="btn-back-pud" (click)="changeState.emit(false)"
              class="fmc-text-button fmc-text-button--chevron-left custom-fmc-text-button">
              <span>
                {{leftButton()}}
              </span>
            </button>

            <lib-button id="right-btn" type="primary" [rightIcon]="true" (clickButton)="changeState.emit(true)" class="dialog-button">
              {{rightButton()}}
            </lib-button>
          </div>
          } @else {
          <lib-button id="right-btn" type="primary" [rightIcon]="true" (clickButton)="changeState.emit(false)" class="dialog-button">
            {{rightButton()}}
          </lib-button>
          }
      }
    </div>
  </app-dialog>
</div>
